import { formatDateNumberWithTime } from '../../../utils/dateFormat';

const addData = (value, name, list, setData, setField) => {
    const newData = list.map(item => {
        if (item.id + '' === name) {
            return { ...item, cantidad: value !== null && value !== '' ? parseFloat(value) : 0 };
        }
        return item;
    })
    setData(newData)
    setField('productos', newData)
}

export const TitleFormData = ({ title, subtitle, aditionaData }) => {
    return (
        <>
            <div className='font-semibold text-xl uppercase col-span-12 dark:text-gray-300 mb-1'>{title} <span className='font-semibold text-sm text-gray-500 dark:text-gray-400'>{subtitle ? ` ${formatDateNumberWithTime(subtitle)}` : ''}</span></div>
            <div><span className='font-semibold text-gray-600 dark:text-gray-300'>{aditionaData}</span></div>
        </>
    )
}

export const TitleSection = ({ title, subtitle, aditionaData }) => {
    return (
        <>
            <div className='font-semibold text-lg uppercase col-span-12 dark:text-gray-300'>{title} <span className='font-semibold text-sm text-gray-500 dark:text-gray-400'>{subtitle ? ` ${formatDateNumberWithTime(subtitle)}` : ''}</span></div>
            <div><span className='font-semibold text-gray-700 dark:text-gray-300'>{aditionaData}</span></div>
        </>
    )
}

export const Divisor = () => {
    return (
        <div className='col-span-12'>
            <hr className='dark:border-gray-500 border-gray-300' />
        </div>
    )
}

export const Loader = () => {
    return (
        <div className='col-span-12 flex h-60 justify-center items-center'>
            <svg aria-hidden='true' className='inline w-20 h-20 text-gray-200 animate-spin dark:text-gray-500 dark:fill-yellow-500 fill-yellow-600' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor' />
                <path d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='currentFill' />
            </svg>
            <span className='sr-only'>Loading...</span>
        </div>
    )
}

export const LoadingSection = () => {
    return (
        <div className='col-span-12 flex w-full h-8 justify-center items-center bg-gray-300 dark:bg-gray-700'>
            <svg aria-hidden='true' className='inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-500 dark:fill-yellow-500 fill-yellow-600' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor' />
                <path d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='currentFill' />
            </svg>
            <span className='sr-only'>Loading...</span>
        </div>
    )
}

export const ButtonSubmit = ({ isSubmitting, disabled = false, textButton = 'Guardar' }) => {
    return (
        <button
            type='input'
            className='
                  dark:text-white
                  focus:ring-4
                  focus:outline-none
                  focus:ring-yellow-300
                  font-semibold
                  rounded-lg
                  text-sm
                  px-4 py-1.5
                  text-center
                  bg-yellow-500 hover:bg-yellow-400
                  dark:bg-yellow-700 dark:hover:bg-yellow-600 disabled:bg-gray-600 dark:disabled:bg-gray-600 disabled:opacity-50
                  dark:focus:ring-yellow-800'
            disabled={isSubmitting || disabled}
        // disabled={isSubmitting}
        >
            {
                isSubmitting ?
                    <>
                        <svg aria-hidden='true' role='status' className='inline w-4 h-4 mr-3  animate-spin dark:text-white' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor' />
                            <path d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='#1C64F2' />
                        </svg>
                        <span className='text-white'>
                            Espere...
                        </span>
                    </>
                    :
                    textButton
            }
        </button>
    )
}

export const ButtonButton = ({ isSubmitting, disabled = false, textButton = 'Guardar', onClick }) => {
    return (
        <button
            type='button'
            onClick={onClick}
            className='
                  dark:text-white
                  focus:ring-4
                  focus:outline-none
                  focus:ring-yellow-300
                  font-semibold
                  rounded-lg
                  text-sm
                  px-5 py-2.5
                  text-center
                  bg-yellow-500 hover:bg-yellow-400
                  dark:bg-yellow-700 dark:hover:bg-yellow-600 disabled:bg-gray-600 dark:disabled:bg-gray-600 disabled:opacity-50
                  dark:focus:ring-yellow-800'
            // disabled={isSubmitting || disabled}
            disabled={isSubmitting}
        >
            {
                isSubmitting ?
                    <>
                        <svg aria-hidden='true' role='status' className='inline w-4 h-4 mr-3  animate-spin dark:text-white' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z' fill='currentColor' />
                            <path d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z' fill='#1C64F2' />
                        </svg>
                        <span className='text-white'>
                            Espere...
                        </span>
                    </>
                    :
                    textButton
            }
        </button>
    )
}

export const InputDataList = ({ list, field, setFieldValue, setDataList, title }) => {
    return (
        list?.length > 0 &&
        <>
            <div className='text-gray-700 dark:text-gray-300'>{title}</div>
            <div
                className='col-span-12 grid dark:text-gray-100 font-semibold grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 max-h-80 overflow-auto bg-gray-100 dark:bg-gray-700 mb-2 p-2 rounded-md text-sm border border-gray-200 dark:border-gray-500'
            >
                {
                    list?.map((i, index) => (
                        <div
                            key={index}
                            className='dark:bg-gray-800 bg-gray-300/70 p-2 rounded-lg'
                        >
                            <label
                                className='flex flex-col mb-1'
                                htmlFor={index}
                            >
                                <span
                                    className=''
                                >
                                    {(i[field.indexLabel]).split(',')[0]}
                                </span>
                                <div
                                    className='flex justify-between'
                                >
                                    <span className='text-yellow-700 dark:text-yellow-600'>
                                        {(i[field.indexLabel]).split(',')[1]}
                                    </span>
                                    <span className='dark:text-red-500 text-red-600'>
                                        {i[field.indexRight]}
                                    </span>
                                </div>
                            </label>
                            <div>
                                <input
                                    id={index}
                                    type='number'
                                    name={i[field.indexId] + ''}
                                    className={`shadow-md outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 font-semibold disabled:opacity-55 disabled:text-gray-500 dark:disabled:text-gray-400 dark:bg-gray-600`}
                                    defaultValue={i.cantidad}
                                    onChange={(e) => addData(e.target.value, e.target.name, list, setDataList, setFieldValue, 'productos')}
                                />
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export const SimpleAlert = ({ data }) => {
    return (
        <div className='col-span-12 p-4 mb-4 text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300 dark:border-yellow-800' role='alert'>
            <div className='flex items-center'>
                <svg className='flex-shrink-0 w-4 h-4 me-2' aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 20 20'>
                    <path d='M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z' />
                </svg>
                <span className='sr-only'>Info</span>
                <h3 className='text-lg font-medium'>NOTA</h3>
            </div>
            <div className='mt-2 mb-4 text-sm'>
                {data}
            </div>
        </div>
    )
}